import React from 'react';
import { motion } from 'framer-motion';
export const PainSection = () => {
  return <section className="py-20 bg-white border-y border-neutral-200" data-id="element-206">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="prose prose-lg mx-auto text-neutral-700" data-id="element-208">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-brand-700" data-id="element-209">
            ¿Te suena familiar?
          </h2>

          <p className="text-xl font-medium text-neutral-900" data-id="element-210">
            Son las 10 de la noche.
          </p>
          <p data-id="element-211">
            Abrís el celular y revisás el chat de clientes, la bandeja de mails,
            las notificaciones de Instagram.
          </p>
          <p className="text-2xl font-bold text-neutral-900" data-id="element-212">Nada.</p>
          <p data-id="element-213">
            O peor: ves el presupuesto que mandaste hace 8 días con el tilde
            azul de "visto" y cero respuesta.
          </p>

          <div className="my-12 p-6 rounded-xl bg-cream-dark border border-neutral-200" data-id="element-214">
            <p className="text-neutral-600 mb-4 font-medium" data-id="element-215">
              Y empezás a pensar lo de siempre:
            </p>
            <ul className="space-y-4 text-lg font-medium text-neutral-800 list-none pl-0" data-id="element-216">
              <li className="flex items-center gap-3" data-id="element-217">
                <span className="text-brand-600" data-id="element-218">"</span>No hay plata en el
                mercado.<span className="text-brand-600" data-id="element-219">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-220">
                <span className="text-brand-600" data-id="element-221">"</span>Mi rubro está muerto.
                <span className="text-brand-600" data-id="element-222">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-223">
                <span className="text-brand-600" data-id="element-224">"</span>Quizás tengo que bajar
                mis precios.<span className="text-brand-600" data-id="element-225">"</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-226">
                <span className="text-brand-600" data-id="element-227">"</span>No sé qué más hacer.
                <span className="text-brand-600" data-id="element-228">"</span>
              </li>
            </ul>
          </div>

          <h3 className="text-2xl font-bold text-neutral-900 mt-12 mb-6" data-id="element-229">
            Pará un segundo.
          </h3>
          <p data-id="element-230">
            Porque lo que estás pensando es comprensible, es humano, y está{' '}
            <strong className="text-brand-600" data-id="element-231">100% equivocado.</strong>
          </p>

          <div className="my-8 pl-6 border-l-4 border-brand-500" data-id="element-232">
            <p className="text-xl font-medium text-neutral-900 m-0" data-id="element-233">
              El problema no es el mercado.
            </p>
            <p className="text-xl font-medium text-neutral-900 mt-2 m-0" data-id="element-234">
              El problema es que nadie te enseñó a vender cuando el mercado no
              ayuda.
            </p>
          </div>

          <p className="text-lg" data-id="element-235">
            Y eso, a diferencia del mercado,{' '}
            <strong className="text-neutral-900" data-id="element-236">
              tiene solución concreta.
            </strong>
          </p>

          <div className="mt-20" data-id="element-237">
            <h2 className="text-2xl sm:text-3xl font-bold text-neutral-900 mb-8 text-center" data-id="element-238">
              Lo que realmente está pasando cuando el celular no suena:
            </h2>

            <div className="space-y-6" data-id="element-239">
              <div className="bg-white p-5 rounded-lg border border-neutral-200 shadow-sm" data-id="element-240">
                <p className="m-0" data-id="element-241">
                  <span className="text-xl mr-2" data-id="element-242">😔</span>{' '}
                  <strong className="text-neutral-900" data-id="element-243">
                    "No hay plata en el mercado"
                  </strong>{' '}
                  <br data-id="element-244" />
                  <span className="text-brand-600 font-bold" data-id="element-245">→</span> El dinero
                  se movió de lugar. No desapareció.
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg border border-neutral-200 shadow-sm" data-id="element-246">
                <p className="m-0" data-id="element-247">
                  <span className="text-xl mr-2" data-id="element-248">😤</span>{' '}
                  <strong className="text-neutral-900" data-id="element-249">
                    "Mi rubro está muerto"
                  </strong>{' '}
                  <br data-id="element-250" />
                  <span className="text-brand-600 font-bold" data-id="element-251">→</span> Tu mensaje
                  no habla el idioma del comprador en crisis.
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg border border-neutral-200 shadow-sm" data-id="element-252">
                <p className="m-0" data-id="element-253">
                  <span className="text-xl mr-2" data-id="element-254">😰</span>{' '}
                  <strong className="text-neutral-900" data-id="element-255">
                    "Tengo que bajar mis precios"
                  </strong>{' '}
                  <br data-id="element-256" />
                  <span className="text-brand-600 font-bold" data-id="element-257">→</span> Tu oferta
                  no está posicionada como solución urgente.
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg border border-neutral-200 shadow-sm" data-id="element-258">
                <p className="m-0" data-id="element-259">
                  <span className="text-xl mr-2" data-id="element-260">😩</span>{' '}
                  <strong className="text-neutral-900" data-id="element-261">
                    "No soy tan bueno como pensaba"
                  </strong>{' '}
                  <br data-id="element-262" />
                  <span className="text-brand-600 font-bold" data-id="element-263">→</span> Nunca te
                  enseñaron a vender en un mercado recesivo.
                </p>
              </div>
              <div className="bg-white p-5 rounded-lg border border-neutral-200 shadow-sm" data-id="element-264">
                <p className="m-0" data-id="element-265">
                  <span className="text-xl mr-2" data-id="element-266">🤯</span>{' '}
                  <strong className="text-neutral-900" data-id="element-267">
                    "No sé por dónde empezar"
                  </strong>{' '}
                  <br data-id="element-268" />
                  <span className="text-brand-600 font-bold" data-id="element-269">→</span> No tenés
                  un sistema. Tenés intuición. En crisis, eso no alcanza.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};